import Layout from '@/pages/Layout';

export default [
    {
        path: '/components',
        redirect: 'noredirect',
        component: Layout,
        name: 'components',
        meta: {
            title: '组件中心',
            icon: 'el-icon-setting'
        },
        children: [
            {
                path: 'form-template',
                component: () => import('@/pages/components/FormTemplate'),
                name: 'form-template',
                id: 'components/form-template',
                meta: {
                    title: '普通表单',
                    icon: 'table'
                },
                isMenuWaterfall:false
            },
            {
                path: 'componentsDesignTitle',
                name: 'componentsDesignTitle',
                id: 'componentsDesignTitle',
                meta: {
                    title: '组件设计',
                    icon: 'iconfont icon-other-zujian bc-custom-menu',
                    color: '#0557d3'
                },
                sortOrder: 10,
                isDesign: true,
                isTitle: true,
                isShow: false,
                isMenuWaterfall:true
            },
            {
                pId: 'componentsDesignTitle',
                path: 'business-tree',
                component: () => import('@/pages/components/BusinessTree'),
                name: 'business-tree',
                id: 'components/business-tree',
                meta: {
                    title: '业务分类',
                    icon: 'iconfont icon-other-yewufenleiweihu bc-custom-menu',
                    color: '#13559a'
                },
                sortOrder: 11,
                isDesign: true,
                isSubMenu: true,
                isMenuWaterfall:true
            },
            {
                pId: 'componentsDesignTitle',
                path: 'dictionary-tree',
                component: () => import('@/pages/components/DictionaryTree'),
                name: 'dictionary-tree',
                id: 'components/dictionary-tree',
                meta: {
                    title: '数据字典',
                    icon: 'iconfont icon-other-shujuzidian bc-custom-menu',
                    color: '#2d86e4'
                },
                sortOrder: 12,
                isDesign: true,
                isSubMenu: true,
                isMenuWaterfall:true
            },
            {
                pId: 'componentsDesignTitle',
                path: 'serialNumber-tree',
                component: () => import('@/pages/components/SerialNumberTree'),
                name: 'serialNumber-tree',
                id: 'components/serialNumber-tree',
                meta: {
                    title: '流水号',
                    icon: 'iconfont icon-other-xinzengliushuihao bc-custom-menu',
                    color: '#0e2781'
                },
                sortOrder: 13,
                isDesign: true,
                isSubMenu: true,
                isMenuWaterfall:true
            },
            {
                path: 'form/:formId',
                component: () => import('@/pages/components/FormTemplate/components/FormSetting'),
                isShow: false,
                name: 'formDetail',
                id: 'components/form/:formId',
                meta: {
                    title: '表单详情',
                    icon: 'table'
                },
                isMenuWaterfall:false
            },
            {
                path: 'form-add',
                component: () => import('@/pages/components/FormTemplate/components/FormSetting'),
                isShow: false,
                name: 'formAdd',
                id: 'components/form-add',
                meta: {
                    title: '添加表单模板',
                    icon: 'table'
                },
                isMenuWaterfall:false
            },
            {
                path: 'form/:formId/create',
                component: () => import('@/pages/components/FormTemplate/FormCreate'),
                isShow: false,
                name: 'formCreate',
                id: 'components/form/:formId/create',
                meta: {
                    title: '新增表单数据',
                    icon: 'table'
                },
                isMenuWaterfall:false
            }
        ]
    }
];



// WEBPACK FOOTER //
// ./src/router/modules/route-component.js